import { render } from "./LoginFromWeChat.vue?vue&type=template&id=db1b43e2"
import script from "./LoginFromWeChat.vue?vue&type=script&lang=js"
export * from "./LoginFromWeChat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__